'use client';

import { useEffect } from "react";

export default function ScrollHandler() {
  useEffect(() => {
    // Handle initial scroll on page load
    const hash = window.location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
      }
    }
  }, []);

  return null;
} 
